import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

const isAxiosError = (error: unknown): error is AxiosError => {
  return error instanceof AxiosError;
};

export const getErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);

export const isEocMissing = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;

  const message = (error.response?.data as { message?: string })?.message;
  const status = error.response?.status;

  return (
    message === "Patient don't have active episode of care" || status === StatusCodes.NOT_FOUND
  );
};

export const isMissingAudioError = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  return error.response?.status === StatusCodes.CONFLICT;
};
